import loggedOutTemplate from './logged-out.tpl.html';
import './logged-out.less';
import { legalLinksComponentModule } from '../../../../shared/app/components/legal-links/legal-links';

export const loggedOutRouteModule = angular
  .module('Q.routes.logged-out', [legalLinksComponentModule])

  .config(function ($stateProvider) {
    $stateProvider.state('loggedOut', {
      url: '/logged-out',
      params: {
        noun: null,
      },
      template: loggedOutTemplate,
      data: {
        pageTitle: 'You have been logged out',
        bodyClass: 'logged-out',
      },
      resolve: {
        accountServiceCheck: /* @ngInject */ function (accountService) {
          return accountService.whenReady();
        },
      },
      controller: /* @ngInject */ function (
        accountServiceCheck,
        $scope,
        $stateParams,
      ) {
        $scope.noun = $stateParams.noun || 'assessment';
      },
    });
  });
